var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-16.2%",
    width: "132.5%",
    height: "132.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.277326059   0 0 0 0 0.0891428883   0 0 0 0 0.0314179894  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1-Application-iOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-web---Abonnements---Succ\\xE8s-paiement",
    transform: "translate(-382.000000, -280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_icon",
    transform: "translate(382.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FA5725",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FA5724",
    strokeWidth: 2.6,
    strokeLinejoin: "square",
    cx: 20,
    cy: 20,
    r: 18.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(12.000000, 12.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.590677,12.9501591 L3.05069535,0.410177529 C2.50379198,-0.136725843 1.61712493,-0.136725843 1.07107608,0.410177529 L0.410177529,1.07005062 C-0.136725843,1.61712489 -0.136725843,2.50379202 0.410177529,3.04984083 L12.9501591,15.5898225 C13.4972334,16.1367258 14.3839005,16.1367258 14.9299493,15.5898225 L15.5898224,14.9299493 C16.1377513,14.3839005 16.1377513,13.4970625 15.590677,12.9501591 L15.590677,12.9501591 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9501591,0.410177529 L0.410177529,12.9501591 C-0.136725843,13.4970625 -0.136725843,14.3839005 0.410177529,14.9299493 L1.07005062,15.5898225 C1.61712493,16.1367258 2.50379198,16.1367258 3.04984083,15.5898225 L15.590677,3.0506954 C16.1377513,2.50379202 16.1377513,1.61712489 15.590677,1.07107608 L14.9308039,0.411202951 C14.3839005,-0.136725843 13.4972334,-0.136725843 12.9501591,0.410177529 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.324eec9a.svg";
export { ForwardRef as ReactComponent };